export default function DOM_Attribute() {
  return (
    <div>
      <h1>DOM_Attribute</h1>
      <p>This is the DOM_Attribute component.</p>
    </div>
  );
}